module.exports = __webpack_public_path__ + "static/media/handicap_sign.9056e828.svg";